// extracted by mini-css-extract-plugin
export var title = "Title-module--title--35eae";